import { render, staticRenderFns } from "./groups_list.vue?vue&type=template&id=a0637a08"
import script from "./groups_list.vue?vue&type=script&lang=js"
export * from "./groups_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports